module.exports = __webpack_public_path__ + "img/home-active.7f964ffc.svg";